// extracted by mini-css-extract-plugin
module.exports = {"container":"_3cgjoZ","interaction":"LQhHlB","heading":"_7nj9cH","login":"_2zr_kA","buttonWrapper":"_2QNBqs","button":"_2jY1zy","button1":"_1Xds-w","register":"_3lEVBQ"};